import axios from "axios";
import store from "@/store";

export default {
    state: {
        adminUsers: [],
        adminUsersTrainers: [],
        adminUsersAttendee: [],
        adminSessions: [],
        adminCourses: [],
        adminBatches: [],
        adminOrders: [],
        adminConfig: [],
        adminConfigData: {},
        adminProductTypeData: []
    },
    getters: {
        adminUsers(state) {
            return state.adminUsers
        },

        adminUsersTrainers(state) {
            return state.adminUsersTrainers
        },

        adminUsersAttendee(state) {
            return state.adminUsersAttendee
        },

        adminSessions(state) {
            return state.adminSessions
        },

        adminCourses(state) {
            return state.adminCourses
        },

        adminBatches(state) {
            return state.adminBatches
        },

        adminOrders(state) {
            return state.adminOrders
        },
        adminConfig: state => state.adminConfig,
        adminConfigData: state => state.adminConfigData,
        adminProductTypeData: state => state.adminProductTypeData
    },
    actions: {
        async getAdminUsers({ commit }, { query }) {
            store.commit("setIsLoading", true);
            try {
              const res = await axios.get("admin/users", {
                params: query,
              });
              const data = res && res.data && res.data.data;
              commit("setAdminUsers", data);
              store.commit("setIsLoading", false);
            } catch(err) {
                store.commit("setIsLoading", false);
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        },

        async getAdminUsersTrainers({ commit }, payload) {
            store.commit("setIsLoading", true);
            const res = await axios.get(`admin/users/trainer/${payload && payload.userId}/view`, payload);

            const data = res && res.data && res.data.data;
            commit("setAdminUsersTrainers", data);
            store.commit("setIsLoading", false);
        },

        async getAdminUsersAttendee({ commit }, payload) {
            store.commit("setIsLoading", true);
            const res = await axios.get(`admin/users/attendee/${payload && payload.userId}/view`, payload);

            const data = res && res.data && res.data.data;
            commit("setAdminUsersAttendee", data);
            store.commit("setIsLoading", false);
        },

        async getAdminSessions({ commit }, payload) {
            const res = await axios.get("admin/sessions", payload);
            const data = res && res.data && res.data.data;

            commit("setAdminSessions", data);
        },

        async getAdminCourses({ commit }, payload) {
            const res = await axios.get("admin/courses", payload);
            const data = res && res.data && res.data.data;

            commit("setAdminCourses", data);
        },

        async getAdminBatches({ commit }, payload) {
            const res = await axios.get("admin/batches", payload);
            const data = res && res.data && res.data.data;

            commit("setAdminBatches", data);
        },

        async getAdminOrders({ commit }, payload) {
            const res = await axios.get("admin/orders", payload);
            const data = res && res.data && res.data.data;

            commit("setAdminOrders", data);
        },
        async updateAdminTrainerPlatformFees({ commit }, payload) {
          try {
            const res = await axios.put("admin/users/toggle/" + payload);
            return res && res.data;
          } catch(err) {
            throw err.response && err.response.data || err ;
          }
        },
        async updateAdminUserTimeToJoin({ commit }, payload) {
            try {
                const res = await axios.put("admin/users/time-to-join/" + payload);
                return res && res.data;
            } catch(err) {
                throw err.response && err.response.data || err ;
            }
        },
        async updateUserStatus({ commit }, payload) {
            try {
                const res = await axios.put("admin/users/" + payload.id, {
                    "reason": "",
                    "status": Number(!payload.is_active)
                });
                return res && res.data;
            } catch(err) {
                throw err.response && err.response.data || err ;
            }
        }, 
        async getAdminConfig({ commit }) {
            try {
                const res = await axios.get("admin/nav-config");
                const data = res && res.data && res.data.data;
                commit("setAdminConfig", data);
            } catch(err) {
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        },
        async getAdminConfigData({ commit }, payload) {
            store.commit("setIsLoading", true);
            try {
                const res = await axios.get("admin/nav-config-list", {params: payload});
                const data = res && res.data;
                commit("setAdminConfigData", data)
                store.commit("setIsLoading", false);
            } catch(err) {
                store.commit("setIsLoading", false);
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        },
        async getProductTypeList({ commit }) {
            try {
                const res = await axios.get("admin/product-type-list");
                const data = res && res.data && res.data.data;
                commit("setAdminProductTypeData", data);
            } catch(err) {
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        },
        async getConfigDataDetails({ commit }, payload) {
            store.commit("setIsLoading", true);
            try {
                const res = await axios.get("admin/nav-config/" + payload.id);
                const data = res && res.data && res.data.data;
                store.commit("setIsLoading", false);
                return data
            } catch(err) {
                store.commit("setIsLoading", false);
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        },
        async updateConfigDataDetails({ commit }, payload) {
            store.commit("setIsLoading", true);
            try {
                const res = await axios.post("admin/nav-config-data-update", payload);
                // const data = res && res.data && res.data.data;
                store.commit("setIsLoading", false);
                store.commit("setIsSuccess", res && res.data && res.data.message);
            } catch(err) {
                store.commit("setIsLoading", false);
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        },
        async addConfigDataDetails({ commit }, payload) {
            store.commit("setIsLoading", true);
            try {
                const res = await axios.post("admin/nav-config-data", payload);
                // const data = res && res.data && res.data.data;
                store.commit("setIsLoading", false);
                store.commit("setIsSuccess", res && res.data && res.data.message);
            } catch(err) {
                store.commit("setIsLoading", false);
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        },
        async deleteConfigRecord({ commit }, payload) {
            store.commit("setIsLoading", true);
            try {
                const res = await axios.delete("admin/nav-config/" + payload.id);
                // const data = res && res.data && res.data.data;
                store.commit("setIsLoading", false);
                store.commit("setIsSuccess", res && res.data && res.data.message);
            } catch(err) {
                store.commit("setIsLoading", false);
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        },
        async getTrainerStatistics({ commit }, paylaod) {
            store.commit("setIsLoading", true);
            try {
                const res = await axios.get("admin/all-connected-info", {params: paylaod});
                store.commit("setIsLoading", false);
                return res && res.data && res.data.data;
            } catch(err) {
                store.commit("setIsLoading", false);
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message});
                throw err.response && err.response.data || err ;
            }
        }
    },
    mutations: {
        setAdminUsers(state, data) {
            state.adminUsers = data;
        },

        setAdminUsersTrainers(state, data) {
            state.adminUsersTrainers = data
        },

        setAdminUsersAttendee(state, data) {
            state.adminUsersAttendee = data
        },

        setAdminSessions(state, data) {
            state.adminSessions = data;
        },

        setAdminCourses(state, data) {
            state.adminCourses = data;
        },

        setAdminBatches(state, data) {
            state.adminBatches = data;
        },

        setAdminOrders(state, data) {
            state.adminOrders = data;
        },
        setAdminConfig(state, data) {
            state.adminConfig = data;
        },
        setAdminConfigData(state, data) {
            state.adminConfigData = data;
        },
        setAdminProductTypeData(state, data) {
            state.adminProductTypeData = data;
        }
    }
}